import { ThemeProps } from "./types";
import { useColors } from "./useColors";

export const useColor = ({ color, colorName }: ThemeProps) => {
  const colors = useColors();
  return color || (colorName ? colors[colorName] : undefined);
};
